<template>
    <div class="examData-wrapper">
        <div class="top-tab">
            <el-tabs v-model="tabName" class="tabs-full" @tab-click="toggleTab" v-if="level == 1">
                <el-tab-pane label="理论题" name="examCenterExamDataTheory"></el-tab-pane>
                <el-tab-pane v-if="modules.goods_info_collect" label="商品信息采集与处理" name="examCenterExamDataGoodsInfo"></el-tab-pane>
                <el-tab-pane v-if="modules.shop_decoration" label="网店装修" name="examCenterExamDataStoreDecorate"></el-tab-pane>
                <el-tab-pane v-if="modules.shop_management" label="网店管理" name="examCenterExamDataStoreManage"></el-tab-pane>
                <el-tab-pane v-if="modules.network_promotion" label="网络推广" name="examCenterExamDataNetworkPromote"></el-tab-pane>
                <el-tab-pane v-if="modules.store_customer_service" label="网店客户服务" name="examCenterExamDataStoreCustomer"></el-tab-pane>
                <el-tab-pane v-if="modules.data_capture_clean" label="电子商务数据收集与清洗" name="examCenterExamDataECommerceData"></el-tab-pane>
            </el-tabs>
            <el-tabs v-model="tabName" class="tabs-full" @tab-click="toggleTab" v-else>
                <el-tab-pane label="理论题" name="examCenterExamDataTheory"></el-tab-pane>
                <el-tab-pane v-if="modules.store_visual_design" label="网店视觉设计" name="examCenterExamDataOnlineShopVisualDesignDetail"></el-tab-pane>
                <el-tab-pane v-if="modules.network_marketing" label="网络营销" name="examCenterExamDataCyberMarketing"></el-tab-pane>
                <el-tab-pane v-if="modules.online_transaction_management" label="网上交易管理" name="examCenterExamDataOnlineTradeManageDetail"></el-tab-pane>
                <el-tab-pane v-if="modules.store_customer_service_level_three === 42" label="网络客户服务" name="examCenterExamDataCyberCustomer"></el-tab-pane>
                <el-tab-pane v-if="modules.store_customer_service_level_three === 43" label="网络客户服务" name="examCenterExamDataStoreCustomer"></el-tab-pane>
                <el-tab-pane v-if="modules.data_analysis_application" label="电子商务数据分析与应用" name="examCenterExamDataECommerceAnalysisApplicationDetail"></el-tab-pane>
            </el-tabs>
            <div class="right">
                <el-button type="primary" @click="goBack">返回</el-button>
            </div>
        </div>
        <div class="container">
            <router-view />
        </div>
    </div>
</template>

<script>
    import { examModules } from '@/utils/apis.js'
    export default {
        data() {
            return {
                examId: this.$route.query.examId || null,
                studentId:this.$route.query.id || null,
                tabName: 'examCenterExamDataTheory',
                level:this.$route.query.level || null,
                modules: {}
            }
        },
        created() {
            this.tabName = this.$route.meta.tabName;
            this.getExamModules()
        },
        methods: {
            toggleTab(tab) {
                let module = void 0
                // 四级
                if (tab.name === 'examCenterExamDataGoodsInfo') {
                    module = this.modules.goods_info_collect || void 0
                }
                if (tab.name === 'examCenterExamDataStoreDecorate') {
                    module = this.modules.shop_decoration || void 0
                }
                if (tab.name === 'examCenterExamDataStoreManage') {
                    module = this.modules.shop_management || void 0
                }
                if (tab.name === 'examCenterExamDataNetworkPromote') {
                    module = this.modules.network_promotion || void 0
                }
                if (Number(this.level) === 1 && tab.name === 'examCenterExamDataStoreCustomer') {
                    module = this.modules.store_customer_service || void 0
                }
                if (tab.name === 'examCenterExamDataECommerceData') {
                    module = this.modules.data_capture_clean || void 0
                }
                // 三级
                if (tab.name === 'examCenterExamDataOnlineShopVisualDesignDetail') {
                    module = this.modules.store_visual_design || void 0
                }
                if (tab.name === 'examCenterExamDataCyberMarketing') {
                    module = this.modules.network_marketing || void 0
                }
                if (tab.name === 'examCenterExamDataOnlineTradeManageDetail') {
                    module = this.modules.online_transaction_management || void 0
                }
                if (tab.name === 'examCenterExamDataCyberCustomer') {
                    module = this.modules.store_customer_service_level_three || void 0
                }
                if (Number(this.level) === 2 && tab.name === 'examCenterExamDataStoreCustomer') {
                    module = this.modules.store_customer_service_level_three || void 0
                }
                if (tab.name === 'examCenterExamDataECommerceAnalysisApplicationDetail') {
                    module = this.modules.data_analysis_application || void 0
                }
                this.$router.push({
                    name: tab.name,
                    query: {
                        id:this.studentId,
                        examId:this.examId,
                        method: 'teaExam',
                        level:this.level,
                        moduleId: module
                    }
                })
            },
            goBack() {
                this.$router.push({
                    path: '/examCenter/examData/student',
                    query: {
                        examId: this.examId,
                        level: this.level
                    }
                })
            },
            getExamModules() {
                examModules(this.$route.query.examId).then((res) => {
                    this.modules = res.data
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .examData-wrapper {
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        .container {
            height: 1%;
            flex: 1;
            position: relative;
        }
    }
    .top-tab {
        margin: 0 20px;
        display: flex;
        justify-content: space-between;
        position: relative;
        &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 1px;
            background: #F1F5FF;
        }
        .right {
            width: 90px;
            text-align: right;
            margin-top: -5px;
        }
    }
    .tabs-full {
        width: 1%;
        flex: 1;
        ::v-deep {
            .el-tabs__nav-wrap::after {
                content: none;
            }
            .el-tabs__header {
                margin-bottom: 0;
            }
            .el-tabs__active-bar {
                display: none;
            }
            .el-tabs__item {
                height: 46px;
                line-height: 46px;
                font-size: 16px;
                font-weight: normal;
                border-radius: 4px 4px 0 0;
                &.is-active {
                    background: #E7F6EF;
                }
            }
            .el-tabs__item.is-top:nth-child(2) {
                padding-left: 20px;
            }
            .el-tabs__item.is-top:last-child {
                padding-right: 20px;
            }
        }
    }
</style>